export default "__VITE_ASSET__DU1HPn30__"